export default "__VITE_ASSET__5xapzlTe__"